export default {
  fromResource (resource, type) {
    switch (type) {
      case 'address':
        return resource ? resource?.street + ', ' + resource?.number : null
      case 'bill-to-pay':
        return 'Conta #' + resource?.id
      case 'campaign':
        return 'Campanha #' + resource?.id
      case 'customer':
      case 'item':
      case 'supplier':
      case 'user':
        return resource?.name
      case 'exam':
        return 'Exame #' + resource?.id
      case 'indication':
        return 'Indicação #' + resource?.id
      case 'lead':
        return 'Lead #' + resource?.id
      case 'lesson':
        return 'Aula #' + resource?.id
      case 'order':
        return 'Pedido #' + resource?.id
      case 'vehicle':
        return 'Veículo #' + resource?.id
      default:
        return null
    }
  }
}
